import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { createNotification, changeNotification, resetFilters } from "../redux/notificationsSagas";
import { Filters } from "./Filters";
import { MainModal } from "../../../../components/modal/MainModal";
import { isStartDateGreaterThanEndDate } from "./Schedule";

export const PopupFilters = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const {
    selected: { notificationId, message, organization_ids, title, start_on, end_on }
  } = useSelector((state) => state.notifications);

  const isEditMode = typeof notificationId == "number";

  const save = () => {
    dispatch(isEditMode ? changeNotification() : createNotification());
    close();
  };

  const close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const primaryButtonDisabled = !(
    message.length &&
    organization_ids.length > 0 &&
    title &&
    title.trim() &&
    title.length <= 64 &&
    !isStartDateGreaterThanEndDate(start_on, end_on, !!end_on)
  );

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={close}
        headerText={`${isEditMode ? "Edit" : "Add"} Notification`}
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        parentSelector=".notifications"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={() => save()}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height="85vh"
        width={900}
      >
        <Filters />
      </MainModal>
    </>
  );
};
